import { Button, useAppDisplayModeContext } from '@archipro-design/aria';
import { AddLine } from '@archipro-design/icons';

interface FilterBarNewBoardButtonProps {
    onClick?: () => void;
}

const FilterBarNewBoardButton = ({ onClick }: FilterBarNewBoardButtonProps) => {
    const { mobile } = useAppDisplayModeContext();
    return (
        <Button
            color="dark"
            iconBefore={<AddLine />}
            size={24}
            variables={{
                buttonPadding: 16,
                iconPadding: 4,
            }}
            onClick={(e) => {
                e.preventDefault();
                onClick && onClick();
            }}
        >
            {mobile ? `New Board` : `NEW BOARD`}
        </Button>
    );
};

export default FilterBarNewBoardButton;
